import React from 'react'
import styled from 'styled-components'

const SysStatusIcon = ({ status }: { status: string }) => {
  const iconUrl = () => {
    const shortStatus = status?.split('_')[0]

    switch (shortStatus) {
      case 'HEATING':
        return '/img/flame.svg'
      case 'COOLING':
        return '/img/snowflake.svg'
    }
  }

  return (
    <S.Icon
      role="img"
      aria-hidden="true"
      style={{ backgroundImage: `url(${iconUrl()})` }}
    />
  )
}

export default SysStatusIcon

const S = {
  Icon: styled.span`
    display: inline-block;
    width: 25px;
    height: 25px;
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 5px;
    vertical-align: bottom;
  `
}
